import type { LegacyRef, MouseEvent } from 'react';
import { Component, createRef } from 'react';

import ArrowIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/arrow-down';
import NewWindowIconSm from '@skyscanner-internal/backpack-web/bpk-component-icon/sm/new-window';
import BpkLink, {
  BpkButtonLink,
} from '@skyscanner-internal/backpack-web/bpk-component-link';
import BpkPopover from '@skyscanner-internal/backpack-web/bpk-component-popover';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import { withI18n } from '../../../hotels-utils/services/i18n';

import type {
  I18n,
  Price,
} from '@skyscanner-internal/landing-pages-shared-types/types-shared/hotels-components/types';

import STYLES from './NormalRates.module.scss';

type RateProps = {
  i18n: I18n;
  rate?: Price;
  onClick?: Function;
  detailUrl?: string;
};

const Rate = ({
  detailUrl = undefined,
  i18n,
  onClick = undefined,
  rate = undefined,
}: RateProps) => {
  const url = rate?.funnelType === 'dbook' ? detailUrl : rate?.deepLink;

  const partnerName = () =>
    rate?.funnelType === 'meta' ? (
      <div>
        <BpkText
          textStyle={TEXT_STYLES.caption}
          className={STYLES.Rate__nameEx}
        >
          {rate.name}
        </BpkText>
        <NewWindowIconSm className={STYLES.Rate__newWindowIconSmall} />
      </div>
    ) : (
      <BpkText textStyle={TEXT_STYLES.caption} className={STYLES.Rate__name}>
        {rate?.name}
      </BpkText>
    );

  return (
    <div className={STYLES.NormalRates}>
      <BpkLink
        className={STYLES.Rate}
        href={url ?? null}
        blank
        onClick={(e: MouseEvent<HTMLAnchorElement>) => {
          e.stopPropagation();
          onClick?.(false, rate, rate?.funnelType === 'dbook', 'other');
        }}
      >
        {partnerName()}
        <BpkText textStyle={TEXT_STYLES.label1}>
          {rate && i18n.formatCurrency(rate.price)}
        </BpkText>
      </BpkLink>
    </div>
  );
};

type NormalRatesProps = {
  i18n: I18n;
  rates: Price[];
  onClick?: Function;
  detailUrl?: string;
};

type NormalRatesState = {
  isOpen: boolean;
};

class NormalRates extends Component<NormalRatesProps, NormalRatesState> {
  static defaultProps = {
    onClick: undefined,
    detailUrl: undefined,
  };

  private target: LegacyRef<HTMLSpanElement> | undefined;

  constructor(props: NormalRatesProps) {
    super(props);

    this.state = {
      isOpen: false,
    };
    this.target = createRef();
  }

  openPopover = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({
      isOpen: true,
    });
  };

  closePopover = () => {
    this.setState({
      isOpen: false,
    });
  };

  render() {
    const { detailUrl, i18n, onClick, rates } = this.props;

    return (
      <div className={STYLES.NormalRates}>
        <BpkPopover
          id="normal-rate-popover"
          target={
            <span ref={this.target}>
              <BpkButtonLink
                onClick={this.openPopover}
                className={STYLES.BtnLinkRow}
              >
                {i18n.translate('Button_seeMore')}
                <ArrowIcon className={STYLES.NormalRates__arrowIcon} />
              </BpkButtonLink>
            </span>
          }
          onClose={this.closePopover}
          isOpen={this.state.isOpen}
          label=""
          closeButtonText={i18n.translate('Modal_close')}
        >
          {rates.map((rate) => (
            <Rate
              i18n={i18n}
              rate={rate}
              onClick={onClick}
              detailUrl={detailUrl}
              key={rate.partnerId}
            />
          ))}
        </BpkPopover>
      </div>
    );
  }
}

export default withI18n(NormalRates);
